export default "__VITE_PUBLIC_ASSET__274d9424__"